/**
 * StatusBadge — status is NEVER colour alone: always icon + text + colour (§1.5, §6, WCAG 1.4.1).
 * Maps an AnomalyStatus to the right tone + glyph + Russian label.
 */
import type { AnomalyStatus } from "@/types/contract";
import { Badge } from "@/components/ui/Badge";
import type { BadgeTone } from "@/components/ui/Badge";
import { AlertIcon, CheckIcon, CheckCircleIcon } from "@/components/ui/icons";

const map: Record<
  AnomalyStatus,
  { tone: BadgeTone; label: string; Icon: typeof AlertIcon }
> = {
  open: { tone: "danger", label: "Открыто", Icon: AlertIcon },
  acknowledged: { tone: "warning", label: "В работе", Icon: CheckIcon },
  resolved: { tone: "accent", label: "Решено", Icon: CheckCircleIcon },
};

export function StatusBadge({ status }: { status: AnomalyStatus }) {
  const { tone, label, Icon } = map[status];
  return (
    <Badge tone={tone}>
      <Icon size={13} />
      {label}
    </Badge>
  );
}
